<template>
  <d-container fluid>
    <d-row>
      <main class="main-content col-lg-12 col-md-12 col-sm-12 p-0">
        <!-- Content -->

        <slot />
        <main-footer />
      </main>
    </d-row>
  </d-container>
</template>

<script>
import MainFooter from "@/components/layout/MainFooter/MainFooter.vue";

export default {
  name: "docs",
  components: {
    MainFooter
  }
};
</script>
